import type { PositionChangeData, WaypointPosition } from './types';

/**
 * Builds the position change data object
 */
export function buildPositionChangeData(params: {
	entry: IntersectionObserverEntry;
	currentPosition: WaypointPosition;
	previousPosition: WaypointPosition | undefined;
}): PositionChangeData {
	const { entry, currentPosition, previousPosition } = params;
	const rect = entry.boundingClientRect;
	const viewportTop = 0;
	const viewportBottom = window.innerHeight;

	return {
		currentPosition,
		previousPosition,
		event: null,
		waypointTop: rect.top,
		waypointBottom: rect.bottom,
		viewportTop,
		viewportBottom,
	};
}
